import { render, staticRenderFns } from "./SearchSummary.vue?vue&type=template&id=1dbd2b56&scoped=true"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"
import style0 from "./SearchSummary.vue?vue&type=style&index=0&id=1dbd2b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd2b56",
  null
  
)

export default component.exports